<!--
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-09-07 16:20:21
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-10-28 23:03:59
 * @FilePath: \web\src\components\eshome.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="back_img">
    <div class="title">易维迅轨道交通集成管理平台设备运维服务平台软件V1.0</div>
    <div class="es_img">

      <span @click="add_fau_tab()"
        :style="{ 'color':'white', 'font-size':'20px','left':'18px','top':'50px','position':'absolute','cursor':'pointer'}">
        现存故障{{ faultlist.length }}条
      </span>

      <span @click="add_fau_tab()"
        :style="{ 'color': 'white', 'font-size': '20px', 'left': '18px', 'top': '80px', 'position': 'absolute', 'cursor': 'pointer' }">
        今日发生{{ faultInfo.todayOccuCount }}条
      </span>
      <span @click="add_fau_tab()"
        :style="{ 'color': 'white', 'font-size': '20px', 'left': '18px', 'top': '110px', 'position': 'absolute', 'cursor': 'pointer' }">
        今日解决{{ faultInfo.todaySolveCount }}条
      </span>

      <span @click="add_ins_tab()"
        :style="{ 'color': 'white', 'font-size': '20px', 'left': '18px', 'top': '208px', 'position': 'absolute', 'cursor': 'pointer' }">
        今日巡检计划{{ faultInfo.planCount }}条
      </span>

      <span @click="add_ins_tab()"
        :style="{ 'color': 'white', 'font-size': '20px', 'left': '18px', 'top': '238px', 'position': 'absolute', 'cursor': 'pointer' }">
        今日巡检项{{ faultInfo.todayPlanItemCount }}条
      </span>

      <span @click="add_ins_tab()"
        :style="{ 'color': 'white', 'font-size': '20px', 'left': '18px', 'top': '268px', 'position': 'absolute', 'cursor': 'pointer' }">
        今日完成巡检项{{ faultInfo.todayFinishPlanItemCount }}条
      </span>

      <span @click="add_task_tab()"
        :style="{ 'color': 'white', 'font-size': '20px', 'left': '18px', 'top': '384px', 'position': 'absolute', 'cursor': 'pointer' }">
        今日任务{{ faultInfo.todayTaskCount }}条
      </span>

      <span @click="add_task_tab()"
        :style="{ 'color': 'white', 'font-size': '20px', 'left': '18px', 'top': '424px', 'position': 'absolute', 'cursor': 'pointer' }">
        今日完成任务{{ faultInfo.todayFinishTaskCount }}条
      </span>

      <span @click="add_mat_tab()"
        :style="{ 'color': 'white', 'font-size': '20px', 'left': '310px', 'top': '110px', 'position': 'absolute', 'cursor': 'pointer' }">
        今日材料使用{{ faultInfo.matConsumes }}
      </span>

      <span @click="add_maintain_tab()"
        :style="{ 'color': 'white', 'font-size': '20px', 'left': '310px', 'top': '228px', 'position': 'absolute', 'cursor': 'pointer' }">
        今日保养{{ faultInfo.todayMaintainCount }}条
      </span>
      <span @click="add_maintain_tab()"
        :style="{ 'color': 'white', 'font-size': '20px', 'left': '310px', 'top': '268px', 'position': 'absolute', 'cursor': 'pointer' }">
        今日完成保养{{ faultInfo.todayFinishMaintainCount }}条
      </span>

      <span @click="add_user_tab()"
        :style="{ 'color': 'white', 'font-size': '20px', 'left': '310px', 'top': '384px', 'position': 'absolute', 'cursor': 'pointer' }">
        现场人员{{ faultInfo.userCount }}人
      </span>

      <span @click="add_asset_tab()"
        :style="{ 'color': 'white', 'font-size': '20px', 'left': '310px', 'top': '424px', 'position': 'absolute', 'cursor': 'pointer' }">
        管辖设备{{ faultInfo.assetCount }}个
      </span>

      <div @click="add_fau_tab()" id="finishRatePanel"
        style="position:absolute;left:595px;top:40px;width:250px; height:190px;cursor:pointer"></div>

      <div @click="add_ins_tab()" id="insFinishRatePanel"
        style="position:absolute;left:595px;top:270px;width:250px; height:190px;cursor:pointer"></div>

      <div @click="add_fau_tab()"
        style="position:absolute;left:912px;width:260px; height:468px;padding:10px;cursor:pointer;">
        <div style="width:100%;color:#ddd;font-size:20px;text-align:center;padding-top:15px">未解决故障</div>
        <div style="width:100%;height:395px;margin-top:10px;">
          <div class="content">
            <vueSeamlessScroll :class-option="classOption" :data="faultlist">
              <ul style='list-style-type:none;width:280px;padding:0;margin:0;'>
                <li v-for="item in faultlist" :key="item.id">
                  <table style="width:100px">
                    <tr>
                      <td valign="middle"> <a
                          style="color:#ffffff;font-size:16px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden">{{
                              item.occu_time
                          }}&nbsp;&nbsp;{{ item.org_name }}</a></td>
                    </tr>
                    <tr>
                      <td><a
                          style="color:#ffffff;font-size:16px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden">{{
                              item.equi_name
                          }}</a>
                      </td>
                    </tr>
                    <tr>
                      <td><span class="scroll"> {{ item.level_name }}故障 :未解决</span></td>
                    </tr>
                  </table>
                </li>
              </ul>
            </vueSeamlessScroll>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: 'eshome',

  data () {
    return {
      classOption: {
        // 滚动速度
        step: 0.4,
        // 鼠标悬停停止滚动
        hoverStop: true,
        // 滚动组数
        limitMoveNum: 2,
        // 监听刷新
        openWatch: true
      },

      faultlist: [],
      faultInfo: {},

    }
  },
  methods: {
    //故障上报界面只显示待分配和待解决故障
    init () {
      this.getOutlinedata()
    },
    getOutlinedata () {
      this.$ajax.get('/buss/home/get_outlinedata').then((msg) => {
        this.faultInfo = msg
        this.faultlist = msg.nofinishFaults

        //故障完成率
        let alarmchart = this.$echarts.init(document.getElementById('finishRatePanel'))
        let alarmoption = {
          series: [
            {
              type: 'gauge',
              radius: '100%',
              detail: {
                formatter: '{value}%',
                fontSize: 14,
                color: '#ddd'
              },
              data: [
                {
                  title: {
                    show: true,
                    fontSize: 16,
                    offsetCenter: [0, 80],
                    color: '#ddd'
                  },
                  value: msg.todayOccuCount == 0 ? 100 : ((msg.todayOccuCount - msg.todaySolveCount) * 100 / msg.todayOccuCount).toFixed(2),
                  name: '故障完成率'
                }
              ],
              axisLine:
              {
                lineStyle: {
                  color: [[0.2, '#c23531'], [0.8, 'orange'], [1, 'green']]
                }
              }
            }
          ]
        }
        alarmchart.setOption(alarmoption);

        //巡检完成率
        alarmchart = this.$echarts.init(document.getElementById('insFinishRatePanel'))
        alarmoption = {
          series: [
            {
              type: 'gauge',
              radius: '100%',
              detail: {
                formatter: '{value}%',
                fontSize: 14,
                color: '#ddd'
              },
              data: [
                {
                  title: {
                    show: true,
                    fontSize: 16,
                    offsetCenter: [0, 80],
                    color: '#ddd'
                  },
                  value: msg.todayPlanItemCount == 0 ? 100 : ((msg.todayPlanItemCount - msg.todayFinishPlanItemCount) * 100 / msg.todayPlanItemCount).toFixed(2),
                  name: '巡检完成率'
                }
              ],
              axisLine:
              {
                lineStyle: {
                  color: [[0.2, '#c23531'], [0.8, 'orange'], [1, 'green']]
                }
              }
            }
          ]
        }
        alarmchart.setOption(alarmoption);

      }).catch(err => {
        this.$message.error(err)
      })
    },
    add_fau_tab () {
      if (this.$store.getUser().menus.indexOf('/fault/faultquery') >= 0) {
        this.$emit("add-tab", {
          "id": 48,
          "label": "故障查询",
          "icon": "el-icon-yulanchakan",
          "url": "/fault/faultquery"
        })
      } else {
        this.$message.error("你没有故障查询权限")
      }
    },
    add_ins_tab () {
      if (this.$store.getUser().menus.indexOf('/ins/insmanage') >= 0) {
        this.$emit("add-tab", {
          "id": 65,
          "label": "巡检计划",
          "icon": "el-icon-jihua",
          "url": "/ins/insmanage",
        })
      } else {
        this.$message.error("你没有巡检计划查看权限")
      }
    },
    add_task_tab () {
      if (this.$store.getUser().menus.indexOf('/task/taskquery') >= 0) {
        this.$emit("add-tab", {
          "id": 72,
          "label": "任务查看",
          "icon": "el-icon-chaxun",
          "url": "/task/taskquery",
        })
      } else {
        this.$message.error("你没有任务查看权限")
      }
    },
    add_maintain_tab () {
      if (this.$store.getUser().menus.indexOf('/maintain/maintainquery') >= 0) {
        this.$emit("add-tab", {
          "id": 92,
          "label": "保养查看",
          "icon": "el-icon-paibanchaxun",
          "url": "/maintain/maintainquery"
        })
      } else {
        this.$message.error("你没有保养查看权限")
      }
    },
    add_mat_tab () {
      if (this.$store.getUser().menus.indexOf('/mat/matconsumequery') >= 0) {
        this.$emit("add-tab", {
          "id": 38,
          "label": "物料使用",
          "icon": "el-icon-chakan",
          "url": "/mat/matconsumequery"
        })
      } else {
        this.$message.error("你没有物料使用查看权限")
      }

    },
    add_user_tab () {
      if (this.$store.getUser().menus.indexOf('/system/account') >= 0) {
        this.$emit("add-tab", {
          "id": 12,
          "label": "账户管理",
          "icon": "el-icon-yonghu",
          "url": "/system/account",
        })
      } else {
        this.$message.error("你没有账户管理权限")
      }
    },
    add_asset_tab () {
      if (this.$store.getUser().menus.indexOf('/asset/asset') >= 0) {
        this.$emit("add-tab", {
          "id": 21,
          "label": "设备管理",
          "icon": "el-icon-shebeizuguanli",
          "url": "/asset/asset",
        })
      } else {
        this.$message.error("你没有设备管理权限")
      }
    }
  },

  mounted () {
    this.init()
  },

}
</script>

<style  scoped>
.back_img {
  overflow: hidden;
  background-image: url("../assets/imgs/eshome1920x1080.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: calc(100vh - 113px);
  width: 100%;
}

.title {
  width: 800px;
  text-align: left;
  color: #409eff;
  position: absolute;
  left: calc((100% - 1190px) / 2);
  top: calc(20vh - 80px);
  font-size: 52px;
  font-weight: bolder;
  letter-spacing: 12px;
}

.es_img {
  overflow: hidden;
  background-image: url("../assets/imgs/esmain1190x467.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: calc((100% - 1190px) / 2);
  top: 20vh;
  width: 1190px;
  height: 467px;
}

.login_card {
  background-color: white;
  position: absolute;
  left: calc(15vw);
  top: calc(25vh);
  width: 1190px;
  height: 460px;
  border: 1;
  border-radius: 5px;
}

.content {
  overflow: hidden;
  max-height: 395px;
}

.scroll {
  color: #fa0909;
  font-size: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
